/** @format */

export const HANDLE_SELECT_ROW_DATA = "HANDLE_SELECT_ROW_DATA";
export const HANDLE_FLUSH_ROW_DATA = "HANDLE_FLUSH_ROW_DATA";
